import React, {Component} from 'react';
import {CardBody, Col, Row} from "reactstrap";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import {Button, Checkbox, Form} from 'semantic-ui-react'
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import './styles.scss';
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import * as common from "../../../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import axiosTags from "../../../../../axios/axios_tag";
import axiosParkTags from "../../../../../axios/axios_parktag";
import axiosEventTags from "../../../../../axios/axios_eventtag";
import axiosVisitorTags from "../../../../../axios/axios_visitortag";
import apiConfig from "../../../../../axios/axios_api_services";
import moment from "moment";
import {DatePicker} from "antd";

let delete_const = 'delete';
let update_const = 'update';

function disabledDate(current) {
  return current < moment().subtract(1, "days").endOf("day");
}

class App extends Component {
  state = {
    currentTab: 1, userId: 0, data: [], userObj: null, isScheduled: true, scheduled_date: "", isPublic: false
  };
  async componentDidMount() {
    this.props.data.user.corporateEntity === null ? this.setState({isPublic: true}) : this.setState({isPublic: false})
    await this.setState({userId: this.props.data.user.userId, userObj: this.props.data.user})
    if (this.props.isUpdate) this.setState({scheduled_date: this.props.data.scheduledDate})
    this.tabSwitchHandler(1);
  }

  deleteUserHandler = () => {
    swal({
      title: "Do you want to delete this user? First please enter \"" + delete_const + "\"",
      icon: are_you_sure_icon, closeOnClickOutside: false, content: "input",
    })
      .then((value) => {
        if (value.trim() === delete_const) {
          this.deleteUserAPIHandler()
        } else {
          common.warningAlert("Can't delete user", 1)
        }
      });
  }
  deleteUserAPIHandler = () => {
    this.props.spinnerHandler(true);
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};

    axiosTags.delete(apiConfig.DELETE_USER(this.state.userId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert(response.data.message, 0)
          this.props.closeModalHandler();
          this.props.refreshData();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.getRecentMeetingDetails()
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }
  tabSwitchHandler = (tab) => {
    let {userId} = this.state;
    this.setState({currentTab: tab, data: []})
    switch (tab) {
      case 1:
        this.getRecentMeetingDetails(userId);
        break
      case 2:
        this.getRecentEventParticipations(userId);
        break
      case 3:
        this.getRecentParkTransactions(userId);
    }
  }
  getRecentMeetingDetails = (userId) => {
    this.props.spinnerHandler(true);
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};

    axiosVisitorTags.get(apiConfig.GET_RECENT_MEETINGS(userId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({data: response.data.previewVisitDetails})
        } else {
          this.setState({data: []})
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.getRecentMeetingDetails(userId)
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }
  getRecentEventParticipations = (userId) => {
    this.props.spinnerHandler(true);
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};

    axiosEventTags.get(apiConfig.GET_RECENT_EVENT_PARTICIPATION(userId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({data: response.data.participatedEvents})
        } else {
          this.setState({data: []})
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.getRecentEventParticipations(userId)
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }
  getRecentParkTransactions = (userId) => {
    this.props.spinnerHandler(true);
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};

    axiosParkTags.get(apiConfig.GET_RECENT_PARKING_TRANSACTIONS(userId, this.props.isPublic), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({data: response.data.parkingDetails})
        } else {
          this.setState({data: []})
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.getRecentParkTransactions(userId)
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  isScheduledChangeHandler = () => {
    this.setState({isScheduled: !this.state.isScheduled})
  }

  dateOnChange = (date, dateString) => {
    if (dateString !== null) {
      let date = new Date(dateString);
      this.setState({
        scheduled_date: dateString,
      });
    }
  }

  scheduleDeleteHandler = () => {

    this.state.scheduled_date === "" ? common.notifyMessage("Please select schedule date",0) :
      swal({
        title: "Do you want to delete this user? First please enter \"" +delete_const + "\"",
        icon: are_you_sure_icon, closeOnClickOutside: false, content: "input",
      })
        .then((value) => {
          if (value.trim() === delete_const) {
            this.scheduleDeleteHandler_()
          } else {
            common.warningAlert("Can't delete user",1)
          }
        });
  }

  scheduleDeleteHandler_ = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": 'application/json'
    }
    const obj = JSON.stringify({
      "user": {
        "userId" : this.state.userObj.userId
      },
      "scheduledDate": this.state.scheduled_date + " 00:00:00"
    });

    axiosTags.put(apiConfig.APPROVE_OR_REJECT_DELETE_REQUEST("APPROVED"),obj,{headers:headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert(response.data.message, 0)
          this.props.closeModalHandler();
          this.props.refreshData();
        } else {
          common.warningAlert(response.data.message)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  }

  updateScheduleHandler = () => {
    swal({
      title: "Are you sure do you want to update schedule?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.scheduleDeleteHandler_();
          break;
        default:
          break;
      }
    });
  }

  render() {
    let {currentTab, data, userObj, scheduled_date,isPublic} = this.state;
    let {isUpdate} = this.props;
    let scheduledDateOnPicker = this.state.scheduled_date !== "" ? moment(this.state.scheduled_date, "YYYY-MM-DD") : null;
    let convertedRows = [];
      data.map((obj,index)=>{
        if(currentTab === 1) {
          convertedRows.push({
            time: obj.meetingVisitorDetails ? moment(obj.meetingVisitorDetails.checkIn).format("YYYY-MM-DD HH:mm:ss") : "N/A",
            location: obj.meetingDetails ? obj.meetingDetails.branch ? obj.meetingDetails.branch.name : obj.meetingDetails.location : "N/A",
            extra: obj.meetingDetails && obj.meetingDetails.host1 ? `${obj.meetingDetails.host1.firstName ? obj.meetingDetails.host1.firstName : ""} ${obj.meetingDetails.host1.lastName ? obj.meetingDetails.host1.lastName : ""}` : "N/A"
          })
        }
        if(currentTab === 2) {
          convertedRows.push({
            time: obj.subEventDetails ? moment(obj.subEventDetails.start_time).format("YYYY-MM-DD HH:mm:ss") : "N/A",
            location: obj.subEventDetails ? obj.subEventDetails.name : "N/A",
          })
        }
        if(currentTab === 3) {
          convertedRows.push({
            time: obj.entryTime ? moment(obj.entryTime).format("YYYY-MM-DD HH:mm:ss") : "N/A",
            location: obj.station ? `${obj.station}` : "N/A",
            extra: obj.registrationNo ? obj.registrationNo : "N/A"
          })
        }
      })
    let table_data = {columns: currentTab === 3 ? PARK_TBL_COL : currentTab === 2 ? EVENT_TBL_COL : VISITOR_TBL_COL, rows: convertedRows};
    return (
      <div>
        <MDBModal isOpen={true} toggle={()=>{}} size="lg">
          <MDBModalHeader className={"title"} toggle={this.props.closeModalHandler}>
            Delete User | View Recent Activities
          </MDBModalHeader>
          <MDBModalBody className={'delete-user-prmnt'}>
            <Row>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                {userObj ? <div className={'top-usr-wrapper'}>
                  <p>{`First Name: ${userObj.firstName ? userObj.firstName : "N/A"} `}</p>
                  <p>{`Last Name: ${userObj.lastName ? userObj.lastName : "N/A"} `}</p>
                  <p>{`Email: ${isPublic ? userObj.email ? userObj.email : "N/A" : userObj.corporateEmail ? userObj.corporateEmail : "N/A"} `}</p>
                  <p>{`Mobile: ${userObj.mobile ? userObj.mobile : "N/A"}`}</p>
                </div>:null}
                <div className={'cmn-btn-wrapper'}>
                  <button className={`cmn-btn ${currentTab === 1 ? `active`:``}`} onClick={()=>this.tabSwitchHandler(1)}>Recent Visitor Meetings</button>
                  <button className={`cmn-btn ${currentTab === 2 ? `active`:``}`} onClick={()=>this.tabSwitchHandler(2)}>Recent Event Participation</button>
                  <button className={`cmn-btn ${currentTab === 3 ? `active`:``}`} onClick={()=>this.tabSwitchHandler(3)}>Recent Parking Transactions</button>
                </div>

              </Col>
              <Col xs={12}>
                <MDBDataTable
                  id={"all-corporate-table"}
                  paging={false}
                  searching={false}
                  searchLabel={"Search"}
                  responsive
                  responsiveSm
                  responsiveMd
                  responsiveLg
                  responsiveXl
                  // striped={true}
                  bordered
                  hover
                  data={table_data}/>
              </Col>
              <Row className={'align-items-center'} style={{margin:'0 0 20px 7px'}}>
                <Col>
                  <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                             defaultChecked={(this.state.isScheduled === true) ? true : false}
                             label='Scheduled Delete'
                              disabled={isUpdate}
                             onChange={this.isScheduledChangeHandler}
                  />
                </Col>
                {this.state.isScheduled && <Col>
                  <DatePicker format="YYYY-MM-DD" value={scheduledDateOnPicker}
                              disabledDate={disabledDate}
                              onChange={this.dateOnChange}/>
                </Col>}
              </Row>
              <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                <Button className="px-5" color={'youtube'} onClick={isUpdate ? this.updateScheduleHandler : this.state.isScheduled ? this.scheduleDeleteHandler : this.deleteUserHandler}>{isUpdate ? "Update Schedule Record" : this.state.isScheduled ? "Schedule Delete User" : "Permanently Delete User"}</Button>
              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>
      </div>
    );
  }
}
const VISITOR_TBL_COL = [
  {label: 'Time', field: 'time', sort: 'asc'},
  {label: 'Branch', field: 'location', sort: 'asc'},
  {label: 'Host Name', field: 'extra', sort: 'asc'},
]
const EVENT_TBL_COL = [
  {label: 'Time', field: 'time', sort: 'asc'},
  {label: 'Event Name', field: 'location', sort: 'asc'},
]
const PARK_TBL_COL = [
  {label: 'Time', field: 'time', sort: 'asc'},
  {label: 'Station Name', field: 'location', sort: 'asc'},
  {label: 'Vehicle No', field: 'extra', sort: 'asc'},
]
const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
